import {GenStateReliability} from '../../generated/serverModels/GenStateReliability';

export class StateReliability extends GenStateReliability{
  constructor(reliability?: Partial<StateReliability>) {
    super(reliability);
  }
}
